










import { Vue, Component } from 'vue-property-decorator';
import SimBajaIndividualBase from './SimBajaIndividualBase.vue';

@Component({
  components: { SimBajaIndividualBase },
})
export default class SimBajaIndividualPantalla extends Vue {}
